module.exports = __webpack_public_path__ + "3f16e137/img/SOURCERY_poweredby_web.9819842b.png";